export * from './component/download/download.component';
//export * from "./component/login/login.component";

export * from './download.routing';
